import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard  {

  constructor(private router: Router, private snackbar: MatSnackBar) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    let url: string = state.url;

    return this.checkLogin(url);
  }

  checkLogin(url: string): true | UrlTree {
    let val: string | null = sessionStorage.getItem('isUserLoggedIn');

    if (val != null && val == 'true') {
      if (url == '/login') {
        this.router.navigate(['dashboard']);
      } else {
        return true;
      }
    } else if (val != null && val == 'false') {
      this.snackbar.open('Session expired Please login', undefined, {
        duration: 5000,
        panelClass: 'mandatory',
      });
    } else {
      this.snackbar.open('Please login to use the page', undefined, {
        duration: 5000,
        panelClass: 'mandatory',
      });
    }

    return this.router.parseUrl('/login');
  }
}
